module.exports = __webpack_public_path__ + "static/logo-441c52a0bb3ae8a3a1e310e7e204dfb1.svg";